"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./AIBenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/automate.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "AUTOMATE YOUR BUSINESS",
      description: "Use AI and ML to cope with laborious tasks, removing human-error of the equation and increasing performance.",
    },
    {
      iconSrc: "/decision.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "INCREASE CUSTOMER LOYALTY",
      title: "DATA-BASED DECISIONS",
      description: "Using ML and predictive algorithms, you can gain unique insights into your business, making better decisions.",
    },
    {
      iconSrc: "/predictive.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "PREDICTIVE ANALYTICS",
      description: "Find patterns in your data and forecast the future with accurate AI systems that help you plan ahead.",
    },
    {
      iconSrc: "/competetive.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "BUILD COMPETITIVE ADVANTAGE",
      description:
        "With a custom-based solution working through your data, you generate ownable and unique insights to stand out from the competition.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title9199 animate-left" ref={headerRef}>
           Unlock the power
             
            
            
            <span className="scoping-benefits-highlight"> of your data</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
            By leveraging data-driven insights, AI-powered automation, and predictive analytics, we create  end-to-end solutions that not only meet but anticipate user needs.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
